// tslint:disable-next-line:max-line-length
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Options, ChangeContext, NgxSliderModule } from '@angular-slider/ngx-slider';

import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Slider } from 'src/app/model/slider';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { YourPension } from '../../model/ngrx/your-pension.model';
import { AppState } from '../../store/state/app.state';
import { UtilService } from '../../shared';
import { CurrencyFunctionalityService } from '../../shared/utilities/functionality/currency-functionality.service';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { ToolTipNotificationComponent } from '../../form-elements/tool-tip-notification/tool-tip-notification.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-simple-slider',
    templateUrl: './simple-slider.component.html',
    styleUrls: ['./simple-slider.component.scss'],
    imports: [ReactiveFormsModule, NgClass, ToolTipNotificationComponent, NgxSliderModule]
})
export class SimpleSliderComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input() sliderConfig: Slider;
  @Input() parent: UntypedFormGroup;
  @Input() controlName: string;
  @Input() sliderId: string;
  @Input() disable: boolean;
  @Input() fundAmount: number;
  @Input() enableTooltip: boolean = false;
  @Output() calculatedValueClickHandler: EventEmitter<number> = new EventEmitter<number>();
  // tslint:disable-next-line:no-output-on-prefix
  @Output() scrollEndHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() goToDependantsPageSSHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() displayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();
  manualRefresh: EventEmitter<void> = new EventEmitter<void>();
  yourPensionStore: Observable<YourPension[]>;
  yourPensionData: YourPension;
  calculatedValueLumpSum: string;
  subscription: any;
  value = null;
  options: Options = {
    floor: null,
    ceil: null,
    translate: null,
    showTicksValues: true,
    disabled: true,
    stepsArray: []
  };
  defaultStyle = true;
  yourPensionACE;
  constructor(private store: Store<AppState>, private currencyFunctionalityService: CurrencyFunctionalityService,
    private utilService: UtilService, private activatedRoute: ActivatedRoute, private ref: ChangeDetectorRef,
    private router: Router) {
    this.yourPensionStore = store.select(STORE_VAL.your_pension);
    this.yourPensionACE = this.activatedRoute.snapshot.data.contentData.yourPension;
    this.yourPensionStore.subscribe(res => {
      if (res.length > 0) {
        this.yourPensionData = res[0];
      }
    });
  }

  ngOnInit() {
    this.setSlderValues();
    this.calculate(this.value, this.sliderConfig);
    this.subscription = this.utilService.emitSlider.subscribe(
      (values) => {
        if (values.controlName === this.controlName) { 
          if (values.sliderConfig) {  
            this.sliderConfig = values.sliderConfig
          } 
          this.setSlderValues('scrollEnd', values.value);
        }
      }
    );
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.disable) {
      this.setSlderValues();
    } else {
      this.value = changes.parent.currentValue.controls[this.controlName].value;
      if (this.value && this.sliderConfig) {
        if (changes.parent.currentValue.controls['productType'] &&
          changes.parent.currentValue.controls['productType'].value === 'H' &&
          this.controlName === 'periodofincome') {
          this.setSlderValues();
        }
        this.calculate(this.value, this.sliderConfig);
      }
    }
  }
  setSlderValues = (navType?: string, fundAmount?: number) => {
    this.value = this.parent.controls[this.controlName].value;
    if (this.sliderConfig.stepsArray && this.sliderConfig.stepsArray.length > 0) {
      this.options = {
        floor: this.sliderConfig.minValue,
        ceil: this.sliderConfig.maxValue,
        disabled: this.disable,
        translate: (value: number): string => {
          return (this.sliderConfig.sliderType === 'Years' || this.sliderConfig.sliderType === 'Months') ? value.toString() : value + '%';
        },
        showTicksValues: true,
        stepsArray: this.sliderConfig.stepsArray
      };
      // tslint:disable-next-line:max-line-length
    } else if (this.sliderConfig.sliderType === 'Price' || (this.sliderConfig.sliderType === 'Percentage' && !this.sliderConfig.sliderTitle)) {
      this.options = {
        floor: this.sliderConfig.minValue,
        ceil: this.sliderConfig.maxValue,
        disabled: this.disable,
        translate: (value: number): string => {
          return (value ? value : 0) + '%';
        }
      };
    } else {
      this.options = {
        floor: this.sliderConfig.minValue,
        ceil: this.sliderConfig.maxValue,
        disabled: this.disable,
      };
    }
    this.calculate(this.value, this.sliderConfig, navType, fundAmount);
  }
  calculate = (val: any, sliderConfig: any, type?: string, fundAmount?: number, sliderId?: string): string | number => {
    // Normalize value
    let numericVal = typeof val === 'string' ? parseFloat(val.replace('%', '')) : val;
    if (isNaN(numericVal) || numericVal === null) numericVal = 0;
  
    // DOM styling for tick selection (optional)
    if (!type && sliderId && sliderConfig.stepsArray?.length > 0) {
      const slider = document.getElementById(sliderId);
      if (slider) {
        const ticks = slider.getElementsByClassName('ng5-slider-tick');
        Array.from(ticks).forEach((tick) => {
          const tickVal = parseInt(tick.textContent?.trim().replace('%', '') || '0');
          const tooltip = tick.getElementsByClassName('ng5-slider-inner-tooltip')[0];
          if (tooltip) {
            tooltip.classList.toggle('selected', tickVal === numericVal);
          }
        });
      }
    }
  
    // Handle Percentage slider
    if (sliderConfig.sliderType === 'Percentage') {
      const formatted = numericVal.toFixed(0) + '%';
      this.calculatedValueLumpSum = formatted;
      this.calculatedValueClickHandler.emit(numericVal);
      return formatted;
    }
    if (this.controlName && this.controlName === 'sldrtaxfreeSlider' &&
      this.sliderConfig['fundAmount']) {
      fundAmount = this.sliderConfig['fundAmount'];
    }
    // Handle Price slider
    if (sliderConfig.sliderType === 'Price') {
      let pensionAmount = 0;
      if (fundAmount) {
        val = (fundAmount * val) / 100;
      } else {
        pensionAmount = this.fundAmount ? this.fundAmount :
          (this.yourPensionData.cedingFund ? this.yourPensionData.cedingFund : this.yourPensionData.totalSum);
          if(pensionAmount && pensionAmount != null && isNaN(pensionAmount)) {
            pensionAmount = Number((pensionAmount).toString().replace(/,/g, ''));  
          }

        val = (pensionAmount * val) / 100;
      }
      this.calculatedValueClickHandler.emit(val);
      const reg = new RegExp('^-?\\d+(?:\\.\\d{0,' + 2 + '})?');

      let formattedCurrency = isNaN(val) ? 0 : val.toString().match(reg)[0];
      formattedCurrency = parseFloat(formattedCurrency).toFixed(2);
      this.calculatedValueLumpSum = '£' + CurrencyFunctionalityService.convertNumberToCurrency(formattedCurrency);
      return this.calculatedValueLumpSum;
    }else if (this.router.url !== '/apply/your-pension-savings') {
      this.calculatedValueLumpSum = val;
    }
  
    // Default fallback
    this.calculatedValueClickHandler.emit(numericVal);
    return numericVal;
  };
  
  
  /* common method for converting string into camel case */
  camelCase(idValue) {
    return idValue.toLowerCase()
      // Replaces any - or _ characters with a space
      .replace(/[-_]+/g, ' ')
      // Removes any non alphanumeric characters
      .replace(/[^\w\s]/g, '')
      // Uppercases the first character in each group immediately following a space
      // (delimited by spaces)
      .replace(/ (.)/g, function ($1) { return $1.toUpperCase(); })
      // Removes spaces
      .replace(/ /g, '');
  }

  onUserChangeEnd(changeContext: ChangeContext, sliderConfig, controlName): void {
    sliderConfig.controlName = controlName;
    const emitsliderConfig= { ...sliderConfig, currentValue: changeContext.value };
    this.scrollEndHandler.emit(emitsliderConfig);
    if (controlName !== 'sldrtaxfreeSlider')
    this.calculate(changeContext.value, emitsliderConfig, this.sliderId)
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  goToDependantsPageSS() {
    this.goToDependantsPageSSHandler.emit();
  }
  
  setMinLTA = (errorMessage): string => {
    let MinValue = this.yourPensionACE.minPensionValue; 
    if(this.parent  && this.parent['value'] && this.parent['value']['productType'])  { 
      MinValue = (this.parent['value']['productType'] != 'C') ?  this.yourPensionACE.GIAPensionValue : this.yourPensionACE.minPensionValue;
    }
    errorMessage = errorMessage.replace('[LTAMin]',
      CurrencyFunctionalityService.convertNumberToCurrency(MinValue));
    return errorMessage;
  }
  ngAfterViewInit() {
    this.ref.detectChanges();
  }
  displayMobileTooltipSliderReceiver() {
    this.displayMobileTooltipEmitter.emit();
  }
}